export default [
  {
    path: '/order/invoice',
    name: 'order-invoice',
    meta: {
      index: 1
    },
    component: () => import(/* webpackChunkName: "order-invoice" */ '../../pages/order/views/invoice/index.vue')
  },
  {
    path: '/order/invoice/:id',
    name: 'order-invoice-detail',
    meta: {
      index: 2
    },
    component: () => import(/* webpackChunkName: "order-invoice-detail" */ '../../pages/order/views/invoice/detail.vue')
  },
  {
    path: '/order/detail/:id',
    name: 'order-detail',
    meta: {
      index: 3
    },
    component: () => import(/* webpackChunkName: "order-detail" */ '../../pages/order/views/invoice/order-detail.vue')
  },
  {
    path: '/order/return',
    name: 'order-return',
    meta: {
      index: 1
    },
    component: () => import(/* webpackChunkName: "order-return" */ '../../pages/order/views/return/index.vue')
  },
  {
    path: '/order/return/apply-for-return',
    name: 'order-apply-for-return',
    meta: {
      index: 4
    },
    component: () => import(/* webpackChunkName: "order-return-apply-for-return" */ '../../pages/order/views/return/apply-for-return.vue')
  },
  {
    path: '/order/return/:id',
    name: 'order-return-detail',
    meta: {
      index: 4
    },
    component: () => import(/* webpackChunkName: "order-return-detail" */ '../../pages/order/views/return/detail.vue')
  },
  {
    path: '/order/refund',
    name: 'order-refund',
    meta: {
      index: 1
    },
    component: () => import(/* webpackChunkName: "order-refund" */ '../../pages/order/views/refund/index.vue')
  },
  {
    path: '/order/refund/apply-for-refund',
    name: 'order-apply-for-refund',
    meta: {
      index: 4
    },
    component: () => import(/* webpackChunkName: "order-refund-apply-for-refund" */ '../../pages/order/views/refund/apply-for-refund.vue')
  },
  {
    path: '/order/refund/:id',
    name: 'order-refund-detail',
    meta: {
      index: 2
    },
    component: () => import(/* webpackChunkName: "order-refund-detail" */ '../../pages/order/views/refund/detail.vue')
  }
]
